import httpClient from '../../api/axios-httpclient';
import MisaIdAPI from '@/api/MisaIdAPI.js';
import commonFunc from '@/common/commonFunction';
import { MSEnum } from '../../common/enumeration';

export default {
	// Đăng nhập misa id
	loginMisaId: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: MisaIdAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/login`,
				data: payload
			},
			true
		);
		return res;
	},

	// Tạo link điều hướng sang misa ID
	gennerateLinkRedirectMisaID: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: MisaIdAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/genneratelink`,
				data: payload
			},
			true
		);
		return res;
	},

	// Xác thực 2 lớp
	verifytwofactorMisaId: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: MisaIdAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/verifytwofactor`,
				data: payload
			},
			true
		);
		return res;
	},

	// Chọn cách xác thực khác
	verifyanotherwayMisaId: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: MisaIdAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/verifyanotherway`,
				params: payload
			},
			true
		);
		return res;
	},

	// Gửi lại mã xác thực khác
	sendAgainOTPMisaId: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: MisaIdAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/sendagainotp`,
				data: payload
			},
			true
		);
		return res;
	},

	getUserInfoByMisaId: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: MisaIdAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/getuserinfobymisaid/${payload.MisaId}`
			},
			true
		);
		if (res && res.Success && res.Data) {
			context.commit('updateMisaIdInfo', res.Data);
			return res.Data;
		}

		return null;
	},

	getTokenMisaId: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: MisaIdAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/gettokenmisaid`,
				data: payload
			},
			true
		);
		if (res && res.Data) {
			return res.Data;
		}
		return null;
	}
};
